import { BusinessUnitModel } from '../business-unit.model';
import { DataSpaceModel } from '../dataspace/data-space.model';
import { UserModel } from '../user.model';

export interface GbeUserV4 {
  id: number;
  username: string;
  firstName?: string;
  lastName?: string;
  email: string;
  businessUnit: BusinessUnitModel;
  role: string;
  defaultDataSpace: DataSpaceModel;
}

export function toUserModel(gbeUser: GbeUserV4): UserModel {
  const fullName =
    [gbeUser.firstName, gbeUser.lastName].filter(Boolean).join(' ') || gbeUser.username;

  return {
    id: gbeUser.id,
    userName: gbeUser.username,
    firstName: gbeUser.firstName,
    lastName: gbeUser.lastName,
    fullName,
    email: gbeUser.email,
    role: gbeUser.role,
    businessUnit: {
      id: gbeUser.businessUnit.id,
      name: gbeUser.businessUnit.name,
      description: gbeUser.businessUnit.description,
      createdAt: gbeUser.businessUnit.createdAt
    },
    defaultDataSpace: {
      id: gbeUser.defaultDataSpace.id,
      name: gbeUser.defaultDataSpace.name,
      description: gbeUser.defaultDataSpace.description
    }
  };
}
